import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { required, type } from "@/commons/utils/Rules";
import baseform2 from '../baseForm2';
import PzFormFlujo from "@/components/Flujo/Templates/PzFormFlujoTemplate";
import PzDirection from "@/commons/forms/Fields/PzDirection";
import { mapGetters } from "vuex";
import { getEstadoCivil, getFormasDeEnterarse } from "@/routes/api/resources";

// Los datos personales que el formulario de nuevo socio no pide antes de la oferta.
// Solo entran al modelo cuando el paso los pide: si no, el PUT mandaria vacios y
// pisaria lo que la solicitud ya tiene cargado
var DATOS_ADICIONALES = {
  estado_civil_id: '',
  email: '',
  genero: '',
  cuota_maxima: '',
  destino_prestamo: ''
};
export default {
  name: 'PzPersonFormExtFucerep',
  components: {
    PzFormFlujo: PzFormFlujo,
    PzDirection: PzDirection
  },
  mixins: [baseform2],
  data: function data() {
    var conDatosAdicionales = !!(this.routeData && this.routeData.datos_adicionales);
    return {
      formas_de_enterarse: [],
      marital_status: [],
      genero: [{
        id: 'f',
        name: this.$t('forms_flujo.form1_persona.SP.femenino')
      }, {
        id: 'm',
        name: this.$t('forms_flujo.form1_persona.SP.masculino')
      }],
      formulario2: _objectSpread(_objectSpread({}, conDatosAdicionales ? DATOS_ADICIONALES : {}), {}, {
        comoseentero: '',
        direccion: {}
      }),
      rules_formulario2: {
        comoseentero: [required('')],
        estado_civil_id: [required('')],
        genero: [required('')],
        cuota_maxima: [required(''), type({
          field: '',
          type: 'number'
        })],
        destino_prestamo: [required('')],
        email: [type({
          field: '',
          type: 'email'
        })]
      }
    };
  },
  computed: {
    conDatosAdicionales: function conDatosAdicionales() {
      return !!this.extraData.datos_adicionales;
    }
  },
  created: function created() {
    this.fechtData();
  },
  methods: {
    fechtData: function fechtData() {
      var _this = this;
      this.$store.dispatch('loader/up', {
        trigger: this.$options.name
      });
      var form = getFormasDeEnterarse().then(function (res) {
        _this.formas_de_enterarse = res.data;
      }).catch(function () {
        _this.formas_de_enterarse = [];
      });
      var estado = !this.conDatosAdicionales ? null : getEstadoCivil().then(function (res) {
        _this.marital_status = res.data;
      }).catch(function () {
        _this.marital_status = [];
      });
      return Promise.all([form, estado]).then(function () {}).finally(function () {
        _this.$store.dispatch('loader/down', {
          trigger: _this.$options.name
        });
      });
    }
  }
};